angular.module('tgaAdmin').directive('stResetSearch', () => ({
  restrict: 'EA',
  require: '^stTable',
  link(scope, element, attrs, ctrl) {
    scope.$watch(() => {
      if (
        !Object.keys(ctrl.tableState().search).length
          || !Object.keys(ctrl.tableState().search.predicateObject).length
      ) {
        element.addClass('hide');
      } else {
        element.removeClass('hide');
      }
    }, true);

    return element.on('click', () => scope.$apply(() => {
      const tableState = ctrl.tableState();
      tableState.search.predicateObject = {};
      tableState.pagination.start = 0;
      return ctrl.pipe();
    }));
  },
}));
